import { useContext, useEffect, useMemo, useState } from "react";
import { injectIntl } from "react-intl";
import { sendEvent } from "../../../Base/Utilities/SendEvent";
import EventLogDropdown from "../EventLogDropdown/EventLogDropdown";

import "./EventEditDropdown.scss";
import { FixtureDetailsContext } from "../../../../Config/FixtureDetails";

const EventEditDropdown = (props) => {
  const { editFlow, event, intl, onClose } = props;
  const ctx = useContext(FixtureDetailsContext);
  const { formatMessage } = intl;
  const [activeEditFlowIdx, setActiveEditFlowIdx] = useState(null);

  useEffect(() => {
    if (Array.isArray(editFlow.edit)) {
      setActiveEditFlowIdx(0);
    } else {
      setActiveEditFlowIdx(null);
    }
  }, []);

  const activeEditFlow = useMemo(() => {
    const newEditFlow = activeEditFlowIdx === null ? editFlow.edit : editFlow.edit[activeEditFlowIdx];
    if (!newEditFlow) {
      onClose && onClose();
    }
    return newEditFlow;
  }, [activeEditFlowIdx]);

  const advanceEditFlow = () => {
    if (activeEditFlowIdx !== null) {
      setActiveEditFlowIdx((prev) => prev + 1);
    } else {
      onClose && onClose();
    }
  };

  const deleteEvent = () => {
    let action = {
      action: "sendEvent",
      event: {
        ...event,
        status: "deleted",
      },
      type: "custom",
    };
    sendEvent(action, props);
  };

  const changeEventSubType = (newSubType) => {
    let action = {
      action: "sendEvent",
      event: {
        ...event,
        status: "updated",
        subType: newSubType,
      },
      type: "custom",
    };
    sendEvent(action, props);
  };

  const changeEventOptions = (newOption) => {
    let action = {
      action: "sendEvent",
      event: {
        ...event,
        status: "updated",
        options: { [newOption]: true },
      },
      type: "custom",
    };
    sendEvent(action, props);
  };

  const getActiveOption = () => {
    if (activeEditFlow?.type === "subType") {
      return Object.keys(activeEditFlow?.options ?? {}).find((key) => key === event.subType);
    }
    if (activeEditFlow?.type === "options") {
      return Object.keys(activeEditFlow?.options ?? {}).find((key) => Object.keys(event.options ?? {}).includes(key));
    }
    if (activeEditFlow?.type === "delete") {
      return "false";
    }
    if (activeEditFlow?.type === "customFn" && !!activeEditFlow?.activeFn) {
      return activeEditFlow.activeFn(props, activeEditFlow, ctx);
    }
    return null;
  };

  const handleItemClick = (elemKey) => {
    if (activeEditFlow?.type === "customFn") {
      activeEditFlow?.customFn && activeEditFlow?.customFn(props, elemKey, ctx);
    }
    if (activeEditFlow?.type === "delete") {
      if (elemKey === "true") {
        deleteEvent();
      }
    }
    if (activeEditFlow?.type === "subType") {
      changeEventSubType(elemKey);
    }
    if (activeEditFlow?.type === "options") {
      changeEventOptions(elemKey);
    }
    advanceEditFlow();
  };

  return (
    <EventLogDropdown
      onOutsideClick={onClose}
      contentStyle={{
        width: "100%",
      }}
    >
      <div className="event-edit-dropdown-list">
        {Object.entries(activeEditFlow?.options ?? {}).map(([key, value]) => (
          <span
            key={key}
            onClick={() => {
              handleItemClick(key);
            }}
          >
            {formatMessage({
              id: value,
              defaultMessage: value,
            })}
            {getActiveOption() === key && <i className="fas fa-check event-edit-dropdown-check" />}
          </span>
        ))}
      </div>
    </EventLogDropdown>
  );
};

export default injectIntl(EventEditDropdown);
